import { Injectable } from '@angular/core';
import { RoleGuard } from './role.abstract.guard';

@Injectable({ providedIn: 'root' })
export class ProductionTeamGuard extends RoleGuard {
  role: string[] = ['development', 'designers'];

  override async canActivate(): Promise<boolean> {
    if (await super.canActivate()) {
      return true;
    }

    if (this.permissions.fetching_my_company_product_roles != null) {
      await this.permissions.fetching_my_company_product_roles;
    }

    return this.permissions.hasCompanyProductMemberships();
  }
}
